// src/context/PreviousLocationContext.tsx
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import type { Location } from 'history';

const PreviousLocationContext = createContext<Location | null>(null);

export const PreviousLocationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const location = useLocation();
  const previousLocationRef = useRef<Location | null>(null);

  useEffect(() => {
    previousLocationRef.current = location;
  }, [location]);

  return (
    <PreviousLocationContext.Provider value={previousLocationRef.current}>
      {children}
    </PreviousLocationContext.Provider>
  );
};

export const usePreviousLocation = () => useContext(PreviousLocationContext);
